import LoadingButton from '@mui/lab/LoadingButton'
import { useNotifier } from '@cbgms/base/notifier'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'
import { exportCustomers } from './state/actions'

interface IExportCustomersResponse {
  Data: {
    Status: string
    PresignedURL: string
    Filename: string
  }
}

const downloadFile = (fileUrl: string, filename: string) => {
  const link = document.createElement('a')
  link.href = fileUrl
  link.setAttribute('download', filename)

  document.body.appendChild(link)
  link.click()
  link.remove()
}

const Export = () => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const ouName = useSelector((state: IRootReducerState) => state.auth.user.ou_name)

  const handleExport = async () => {
    if (!ouName) return

    setIsLoading(true)
    try {
      const response = (await dispatch(exportCustomers(ouName))) as unknown as IExportCustomersResponse
      downloadFile(response.Data.PresignedURL, response.Data.Filename || 'customer_export.csv')

      notifier.success(t('LKQConfig.CustomerExportDownloadStarted'))
    } catch (error) {
      notifier.error(t('LKQConfig.CustomerExportDownloadFailed'))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <LoadingButton
      sx={{ marginLeft: '10px' }}
      type='button'
      variant='contained'
      color='primary'
      onClick={handleExport}
      disabled={!ouName || isLoading}
      loading={isLoading}
    >
      {t('LKQConfig.ExportCustomers')}
    </LoadingButton>
  )
}

export default Export
